module.exports = __webpack_public_path__ + "static/cashRank.8ad70f28.png";